export default __webpack_public_path__ + "static/media/icon.shoes.c53e2f4b.svg";